import StatCell from '../../../components/analysis/StatCell';

export default function TestBreakdownTable({ performance }) {
  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-75 text-start align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] leading-snug">Subject</div>
            </td>
            <td className="py-3 px-4 min-w-[108px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Total Score</div>
            </td>
            <td className="py-3 px-4 min-w-[108px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Attempted Correct</div>
            </td>
            <td className="py-3 px-4 min-w-[108px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Attempted Wrong</div>
            </td>
            <td className="py-3 px-4 min-w-[108px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Not Attempted</div>
            </td>
            <td className="py-3 px-4 min-w-[108px] text-center align-middle">
              <div className="line-clamp-2 max-w-[100px] mx-auto leading-snug">Not Visited Qs</div>
            </td>
          </tr>
        </thead>
        <tbody>
          {performance?.map((subject, index) => (
            <tr
              key={index}
              className={`border-b border-[var(--q3-stroke-light)] hover:bg-[var(--q3-surface-dim)] ${index === performance?.length - 1 && 'border-b-0'}`}
            >
              <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
                <div className="flex flex-row justify-start items-center px-4 gap-4">
                  <img src={subject.icon} alt={subject.subject} className="w-6 h-6" />
                  <p className="truncate text-base font-semibold text-[var(--q3-neutral-default)]">{subject.title}</p>
                </div>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)]">
                <StatCell color={subject.color} top={subject.markScored} bottom={subject.totalScore} />
              </td>
              <td className="border-r border-[var(--q3-stroke-light)]">
                <StatCell color={subject.color} top={subject.correct} bottom={subject.totalQuestions} />
              </td>
              <td className="border-r border-[var(--q3-stroke-light)]">
                <StatCell color={subject.color} top={subject.incorrect} bottom={subject.totalQuestions} />
              </td>
              <td className="border-r border-[var(--q3-stroke-light)]">
                <StatCell color={subject.color} top={subject.unattempted} bottom={subject.totalQuestions} />
              </td>
              <td>
                <StatCell color={subject.color} top={subject.notVisited} bottom={subject.totalQuestions} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
